<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>联系人列表</h4>
        </div>
        <div class="main-bd mg20">
            <el-row class="searchSection">
                <el-form ref="form" :inline="true" :model="searcherModel" class="demo-form-inline">
                    <el-form-item label="联系人姓名">
                        <contact-select ref="ContactSelect" v-model="searcherModel.name"
                                        @change="ContactHandleChange"></contact-select>
                    </el-form-item>

                    <el-form-item label="客户ID">
                        <el-input size="small" v-model="searcherModel.customer_id" placeholder="请输入ID"></el-input>
                    </el-form-item>
                    <el-form-item label="客户名称">
                        <CustomerSelect ref="CustomerSelect" v-model="searcherModel.customer_name"
                                        @change="CustomerHandleChange"></CustomerSelect>
                    </el-form-item>
                    <span v-show="isCollapse">
                        <el-form-item label="联系人电话">
                            <el-input size="small" v-model="searcherModel.mobile" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人类型">
                            <el-select v-if="types" size="small" v-model="searcherModel.type" placeholder="请选择">
                                <el-option v-for="(item, key) in types" :key="key" :label="item" :value="key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </span>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索
                        </el-button>
                        <el-button size="small" @click="resetForm()">重置</el-button>
                        <a class="searchCollapse" @click="collapse()">{{ searchTitle }}<i
                                :class="{ 'el-icon-fa-angle-down': isDown, 'el-icon-fa-angle-up': isUp }"></i></a>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row class="addBtn" v-if="Acs('/contacts/create')">
                <el-button @click="createContact()" size="small" type="primary"> + 新增联系人</el-button>
            </el-row>
            <el-table :data="contacts" style="width: 100%" class="tabTopBorder" v-loading="loading">
                <el-table-column label="客户名称">
                    <template slot-scope="scope" >
                        <el-button type="text"  @click="handleDetail(scope.row)" >{{scope.row.customer_name}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="customer_id" label="客户ID"></el-table-column>
                <el-table-column prop="name" label="联系人姓名"></el-table-column>
                <el-table-column prop="mobile" label="电话">
                    <template slot-scope="scope">
                        <span>{{scope.row.mobile}}</span>
                        <span v-if="scope.row.phone_number && scope.row.mobile"><br/>{{scope.row.phone_number}}</span>
                        <span v-else>{{scope.row.phone_number}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="type_name" label="类型"></el-table-column>
                <el-table-column prop="salesman" label="所属业务员"></el-table-column>
                <el-table-column prop="created_at" label="录入时间" width="200"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="updateContact(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button v-if="Acs('/contacts/delete')" @click="handleDelete(scope.row.id)" type="text"
                                   size="small">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>

        <!--新增联系人与编辑联系人的对话框-->
        <ContactForm v-if="showForm"
                     :customerId="customerId"
                     :contactId="contactId"
                     :customerName="customerName"
                     :isShowCustomerName="false"
                     :isUpdateCustomerName="true"
                     :contactsList="contacts"
                     @changeShow="changeShow"
                     @changeCreate="changeCreate"
                     @changeUpdate="changeUpdate"
        ></ContactForm>


    </div>

</template>


<script>
    import Pagination from "~/widgets/Pagination.vue";
    import ContactSelect from "~/widgets/ContactSelect.vue";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import ContactService from "~/services/contact";
    import ProductService from "~/services/product";
    import {STATUS_ON, STATUS_OFF} from "~/services/product";
    import Params from "~/config/params";
    import ContactForm from "~/views/contact/form.vue";

    export default {
        components: {
            Pagination,
            CustomerSelect,
            ContactSelect,
            Params,
            ContactForm
        },

        data() {
            return {
                types: {},
                statuses: {},
                jobs: {},
                searcherModel: {
                    name: "",
                    salesman: "",
                    mobile: "",
                    customer_name: "",
                    customer_id: "",
                    type: ""
                },
                contacts: [],
                loading: true,
                // 分页信息
                linkPage: null,

                showForm: false,//是否展示Dialog对话框
                contactId: "",
                customerId: "",
                isShowCustomerName: true,
                isUpadteCustomerName: false,

                isCollapse: false,
                searchTitle: '展开',
                isDown: true,
                isUp: false,
                customerName: ''
            };
        },
        beforeRouteUpdate: function (to, from, next) {
            let params = this.searcherModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.initListData(params);
        },
        created: function () {
            this.initListData();
            this.types = ContactService.getTypes();
            this.statuses = ContactService.getStatuses();
            this.jobs = ContactService.getJobs();
        },


        methods: {
            // 列表页点击客户名称跳转至详情页
            handleDetail(customer) {
                let routeData = this.$router.resolve({
                    path: "/customers/view",
                    query: {id: customer.customer_id},
                });
                window.open(routeData.href, '_blank');
            },

            // 客户列表展示
            initListData(params = {}) {

                // loading 动画
                this.loading = true;
                //我的联系人列表
                ContactService.getMyList(params).then(res => {
                    this.contacts = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                });
            },

            // 筛选查询
            submitSearch() {
                // loading 动画
                this.loading = true;
                let params = {
                    name: this.searcherModel.name,
                    mobile: this.searcherModel.mobile,
                    customer_id: this.searcherModel.customer_id,
                    customer_name: this.searcherModel.customer_name,
                    type: this.searcherModel.type
                };
                this.initListData(params);

            },

            //重置筛选表单按按钮
            resetForm() {
                this.searcherModel = _.clone(_.extend(this.searcherModel, {
                    name: '',
                    mobile: '',
                    customer_id: '',
                    customer_name: '',
                    type: ''
                }));

                this.$refs["CustomerSelect"].reset();
                this.$refs["ContactSelect"].reset();
                this.$refs["form"].resetFields();
                this.initListData();
            },

            //新增联系人，展示Dialog对话框
            createContact() {
                this.showForm = true;
                this.contactId = '';
                this.customerId = '';
                this.customerName = ''
            },

            //修改联系人，展示Dialog对话框
            updateContact(contact) {
                this.showForm = true;
                this.customerName = contact.customer_name;
                this.contactId = contact.id;
                this.customerId = contact.customer_id;
            },

            //form dialog 的回调 start

            //关闭dialog窗口更新showForm值
            changeShow(isShow) {
                this.showForm = isShow;
            },

            //新增后列表中增加展示新数据
            changeCreate(contact) {
                this.contacts.unshift(contact);
            },

            //编辑后列表数据立即更新
            changeUpdate(obj) {
                let form = obj.form;
                let index = this.contacts.findIndex(function (item) {
                    return item.id == form.id;
                });
                this.contacts = [
                    ...this.contacts.slice(0, index),
                    obj.contact,
                    ...this.contacts.slice(index + 1)
                ];
            },
            //form dialog 的回调 end

            //删除联系人
            handleDelete(id) {
                this.$confirm("此操作是删除操作, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    ContactService.delete(id).then(res => {
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        this.contacts = this.contacts.filter(function (item) {
                            return item.id != id;
                        });
                    });
                }).catch(() => {
                });
            },


            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.searcherModel.customer_name = object.value;
            },

            //联系人远程搜索组件赋值
            ContactHandleChange(object) {
                this.searcherModel.name = object.value;
            },

            collapse() {
                this.isCollapse = !this.isCollapse;
                if (this.isCollapse) {
                    this.searchTitle = "收起";
                    this.isUp = true;
                    this.isDown = false;
                } else {
                    this.searchTitle = "展开";
                    this.isUp = false;
                    this.isDown = true;
                }
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/contact/mycontact.vue